export default __webpack_public_path__ + "static/media/Burkina Faso.15e5c3f7.png";